import cx from "classnames";

import { TableCellContentProps } from "ds/components/Table/Row/CellContent";
import { ariaCellInteractionProps } from "ds/components/Table/hooks/useKeyboardNavigation/ariaCellInteractionProps";
import IacManagementTableCell from "views/Account/IacManagement/components/Table/Row/Cell";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import { ChevronRight } from "components/icons/generated";
import useIacTableStore from "views/Account/IacManagement/components/Table/useIacTableStore";

import styles from "./styles.module.css";
import { RenderGroupRowCellProps } from "../../TableGroupRow";

type IacManagementGroupCellProps = RenderGroupRowCellProps &
  Pick<TableCellContentProps, "children" | "actions" | "role">;

const IacManagementGroupCell = ({
  cellId,
  isFirst,
  children,
  fetchDataLoading,
  loadResources,
  isGroupOpen,
  actions,
  role,
}: IacManagementGroupCellProps) => {
  const isFirstColumnPinned = useIacTableStore((state) => state.isFirstColumnPinned);
  const stickyLeft = isFirst && isFirstColumnPinned;

  return (
    <IacManagementTableCell id={cellId} role={role} stickyLeft={stickyLeft} actions={actions}>
      <Box gap="medium" align="center">
        {isFirst && (
          <ButtonIcon
            loading={fetchDataLoading}
            variant="ghost"
            onPress={loadResources}
            {...ariaCellInteractionProps}
            icon={ChevronRight}
            className={cx(styles.chevronButton, {
              [styles.open]: isGroupOpen,
            })}
          >
            Load Resources
          </ButtonIcon>
        )}
        {children}
      </Box>
    </IacManagementTableCell>
  );
};

export default IacManagementGroupCell;
